import * as actionTypes from '../actions/actionsTypes';

const initialState = {
    isQuizRunning : false,
    loading: true,
    error: null
}

const reducer = ( state = initialState, action) => {
    switch(action.type) {
        case actionTypes.QUIZ_PROTECTION_VALUE:
        return {
            ...state,
            isQuizRunning: action.isQuizRunning,
            error: null,
            loading: false
        }
        case actionTypes.QUIZ_PROTECTION_FETCH_FAIL:
        return {
            ...state,
            error: action.error,
            loading:false
        }
        default: return state;
    }
}

export default reducer;